// removed by extract-text-webpack-plugin
module.exports = {"nav-dots":"NavDots__nav-dots__1hbg0","dot":"NavDots__dot__30CYV","active":"NavDots__active__1SDYQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NavDots/NavDots.scss
// module id = 382
// module chunks = 0